import React from 'react'

const WhyChooseUs = () => {
    const reasons = [
        {
            icon: 'ph-plant',
            title: 'Organik ve Katkısız',
            description: 'Ürünlerimiz %100 organik ve hiçbir katkı maddesi içermez. Doğanın saflığını sofralarınıza taşıyoruz.'
        },
        {
            icon: 'ph-hands-clapping',
            title: 'Geleneksel Yöntemler',
            description: 'Dededen toruna geçen geleneksel üretim yöntemleriyle, el emeği göz nuru ürünler hazırlıyoruz.'
        },
        {
            icon: 'ph-heart',
            title: 'Aile İşletmesi',
            description: 'Küçük bir aile işletmesi olarak, her ürüne kendi evlatlarımıza verircesine özen gösteriyoruz.'
        },
        {
            icon: 'ph-sparkle',
            title: 'Taze Üretim',
            description: 'Siparişlerinizi en taze şekilde ulaştırmak için düzenli ve özenli üretim yapıyoruz.'
        }
    ]

    return (
        <section className="why-choose-us py-80 bg-neutral-50">
            <div className="container container-lg">
                <div className="row g-32 align-items-center">
                    {/* Sol Taraf - Görsel */}
                    <div className="col-lg-6">
                        <div className="why-choose-us__image position-relative rounded-24 overflow-hidden">
                            <img
                                src="assets/images/thumbs/why-choose-us.jpg"
                                alt="Gümüş Pestil Üretimi"
                                className="w-100 h-100 object-fit-cover"
                                style={{ minHeight: 'clamp(300px, 50vw, 500px)' }}
                                onError={(e) => {
                                    e.target.onerror = null
                                    // Placeholder gradient background
                                    e.target.style.display = 'none'
                                    e.target.parentElement.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    e.target.parentElement.style.minHeight = 'clamp(300px, 50vw, 500px)'
                                }}
                            />
                            
                            {/* Mor alan üzerine içerik */}
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center p-40" 
                                 style={{ 
                                     background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%)',
                                     zIndex: 2
                                 }}>
                                <div className="text-white">
                                    <div className="mb-24">
                                        <i className="ph-fill ph-leaf text-white" style={{ fontSize: '48px' }}></i>
                                    </div>
                                    <h3 className="text-white mb-16" style={{ fontSize: '28px', fontWeight: '700' }}>
                                        Doğanın İçinden
                                    </h3>
                                    <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.6', opacity: '0.9' }}>
                                        Anadolu'nun en verimli topraklarından toplanan doğal ürünlerle, 
                                        geleneksel yöntemlerle hazırlanan pestillerimizi keşfedin.
                                    </p>
                                </div>
                            </div>

                            {/* Decorative Element */}
                            <div 
                                className="position-absolute rounded-circle bg-main-600"
                                style={{
                                    width: '120px',
                                    height: '120px',
                                    bottom: '-30px',
                                    right: '-30px',
                                    opacity: '0.2',
                                    zIndex: 1
                                }}
                            />
                            <div 
                                className="position-absolute rounded-circle bg-warning-600"
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    top: '20px',
                                    left: '-20px',
                                    opacity: '0.2',
                                    zIndex: 1
                                }}
                            />
                        </div>
                    </div>

                    {/* Sağ Taraf - İçerik */}
                    <div className="col-lg-6">
                        <div className="why-choose-us__content">
                            <div className="mb-32">
                                <span className="text-main-600 fw-semibold mb-8 d-block">
                                    NEDEN GÜMÜŞ PESTİL?
                                </span>
                                <h2 className="mb-16" style={{ fontSize: '36px', lineHeight: '1.2' }}>
                                    Doğanın Lezzetini <br />
                                    <span className="text-main-600">Sofralarınıza</span> Taşıyoruz
                                </h2>
                                <p className="text-neutral-600 mb-0" style={{ fontSize: '16px' }}>
                                    Gümüş Pestil olarak, geleneksel lezzetleri modern yaşamla buluşturuyoruz. 
                                    Her ürünümüz, özgün tarifler ve doğal malzemelerle özenle hazırlanır.
                                </p>
                            </div>

                            <div className="row gap-16 gap-md-24">
                                {reasons.map((reason, index) => (
                                    <div key={index} className="col-12">
                                        <div className="reason-card d-flex gap-12 gap-md-20 p-20 p-md-28 bg-white rounded-16 transition-2 hover-shadow-md">
                                            <div className="flex-shrink-0">
                                                <div 
                                                    className="w-56 h-56 flex-center rounded-circle bg-main-50"
                                                    style={{ minWidth: '56px' }}
                                                >
                                                    <i className={`ph-fill ${reason.icon} text-main-600 text-32`}></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h5 className="mb-8">{reason.title}</h5>
                                                <p className="text-neutral-600 mb-0" style={{ fontSize: '14px' }}>
                                                    {reason.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .reason-card {
                    border: 1px solid #f0f0f0;
                    transition: all 0.3s ease;
                }
                .reason-card:hover {
                    transform: translateX(8px);
                    border-color: var(--main-600);
                }
                .hover-shadow-md:hover {
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
                }
                
                /* Responsive adjustments */
                @media (max-width: 991px) {
                    .why-choose-us__image {
                        margin-bottom: 40px;
                    }
                    .why-choose-us__image .position-absolute h3 {
                        font-size: 24px !important;
                    }
                    .why-choose-us__image .position-absolute p {
                        font-size: 14px !important;
                    }
                    .reason-card {
                        margin-bottom: 16px;
                    }
                }
                
                @media (max-width: 575px) {
                    .why-choose-us__image .position-absolute {
                        padding: 30px !important;
                    }
                    .why-choose-us__image .position-absolute h3 {
                        font-size: 20px !important;
                    }
                    .why-choose-us__image .position-absolute i {
                        font-size: 36px !important;
                    }
                }
            `}</style>
        </section>
    )
}

export default WhyChooseUs

